<nav class="driver-tabbar">
    <a
        *ngFor="let tab of tabs"
        class="driver-tabbar__tab"
        [class.driver-tabbar__tab--on]="activeTab === tab.id"
        [routerLink]="tab.route"
    >
        <mat-icon [svgIcon]="tab.icon"></mat-icon>
        <span>{{ tab.label }}</span>
    </a>
</nav>
